import React, { useState } from "react";
import "./style.css";
import { CheckCircle } from "../../icons/CheckCircle";
import { Modal } from "../Modal";
import { InputField } from "../InputField";
import { TypePrimaryState } from "../TypePrimaryState";

export const SuccessModal = ({
  show,
  closeFn,
  beneficiaryLoading,
  saveBeneficiary,
  beneficiaryName,
  setBeneficiaryName,
  saveBeneficiaryTxt,
  amount,
  beneficary,
}) => {
  const isBeneficiaryNameValid = (name) => {
    if (name.length >= 3 && name.length <= 50) return true;
    return false;
  };

  const closeModal = () => {
    closeFn();
  };

  const saveAndClose = () => {
    if (beneficiaryLoading.length <= 0) {
      closeModal();
    } else {
      if (isBeneficiaryNameValid(beneficiaryName)) {
        saveBeneficiary();
      }
      closeModal();
    }
  };

  return (
    <Modal closeFn={closeModal} backdropClose={true} show={show}>
      <div className="success-modal-cover">
        <div className="success-modal">
          <div className="header-bg">
            <div className="icon">
              <CheckCircle className="check-icon" />
            </div>
          </div>
          <div className="message">
            <div className="header">Transaction Successful</div>
            <div className="text">Thank you for using Express Wages.</div>
          </div>
        </div>
        <div className="action">
          <div className="text">Would you like to save this card?</div>
          <InputField
            readOnly={saveBeneficiaryTxt.toLowerCase() == "saved"}
            baseInputBaseInputClassName="beneficiary-name"
            baseInputPlaceholder="Name this card"
            baseInputValidation={false}
            className="input-field-instance"
            divClassName="design-component-instance-node"
            label=""
            showInfo={false}
            state="normal"
            value={beneficary?.name || beneficiaryName}
            setValue={setBeneficiaryName}
            isValid={isBeneficiaryNameValid}
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <TypePrimaryState
            baseButtonDivClassName="type-primary-state-normal-outline-false-link-false"
            baseButtonText={"Done"}
            className="button"
            onClick={saveAndClose}
            baseButtonShowRightIcon={false}
            baseButtonShowLeftIcon={false}
          />
        </div>
      </div>
    </Modal>
  );
};
